import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function TagButton({ children, className, href, onClick, isActive, ...props }) {
  return href ?
      <a
        href={href}
        className={cx('component', isActive ? 'active' : '', className)}
        onClick={onClick}
        role="button"
        tabIndex={0}
        {...props}
      >
        {children}
      </a>
    : <span
        className={cx('component', isActive ? 'active' : '', className)}
        onClick={onClick}
        role="button"
        tabIndex={0}
        {...props}
      >
        {children}
      </span>;
}

TagButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
};

TagButton.defaultProps = {
  children: '',
  className: '',
  href: '',
  onClick: () => {},
  isActive: false,
};
